import React from "react";
import "./productInfoCards.css";

const CardGrid = ({ cards }) => {


  return (
    <div className="card-grid">
      {cards.map((card, index) => (
        <div className="card-grid-item" key={index}>
          <div className="card-content1">
            <h3>{card.title}</h3>
            <p>{card.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardGrid;
